"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _nimblePicker = _interopRequireDefault(require("emoji-mart/dist/components/picker/nimble-picker"));

var _nimbleEmoji = _interopRequireDefault(require("emoji-mart/dist/components/emoji/nimble-emoji"));

var _draftJs = require("draft-js");

var _attachImmutableEntitiesToEmojis = _interopRequireDefault(require("./modifiers/attachImmutableEntitiesToEmojis"));

var _addEmoji = _interopRequireDefault(require("./modifiers/addEmoji"));

var _emoji = _interopRequireDefault(require("./strategies/emoji"));

var _getEmojiDataFromNative = _interopRequireDefault(require("./utils/getEmojiDataFromNative"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _onChange = _ref.onChange,
      data = _ref.data,
      set = _ref.set,
      _ref$emojiSize = _ref.emojiSize,
      emojiSize = _ref$emojiSize === void 0 ? 16 : _ref$emojiSize,
      _ref$sheetSize = _ref.sheetSize,
      sheetSize = _ref$sheetSize === void 0 ? emojiSize * 2 : _ref$sheetSize;

  var getEmoji = (0, _getEmojiDataFromNative.default)(data, set);
  var store = {
    getEditorState: undefined,
    setEditorState: undefined
  };

  var EmojiComponent = _react.default.memo(function (_ref2) {
    var decoratedText = _ref2.decoratedText,
        children = _ref2.children;
    var foundedEmoji = getEmoji(decoratedText);

    if (foundedEmoji) {
      return _react.default.createElement(_nimbleEmoji.default, {
        emoji: foundedEmoji,
        size: emojiSize,
        sheetSize: sheetSize,
        data: data,
        set: set
      }, children || decoratedText);
    }

    return decoratedText;
  });

  var handleEmoji = function handleEmoji(emojiSymbol) {
    if (!store.getEditorState) {
      throw new Error('Emoji-mart plugin: handle emoji fired on unbinded instace.');
    }

    var newEditorState = (0, _addEmoji.default)(store.getEditorState(), emojiSymbol.native);

    if (!store.setEditorState) {
      throw new Error('Emoji-mart plugin: handle emoji fired on unbinded instace.');
    }

    store.setEditorState(newEditorState);
  };

  var PickerComponent = _react.default.forwardRef(function (props, ref) {
    return _react.default.createElement(_nimblePicker.default, _extends({
      ref: ref,
      set: set,
      data: data,
      sheetSize: sheetSize,
      onSelect: handleEmoji
    }, props));
  });

  var decorators = [{
    strategy: _emoji.default,
    component: EmojiComponent
  }];
  return {
    Emoji: EmojiComponent,
    Picker: PickerComponent,
    decorators: decorators,
    initialize: function initialize(_ref3) {
      var getEditorState = _ref3.getEditorState,
          setEditorState = _ref3.setEditorState;
      store.getEditorState = getEditorState;
      store.setEditorState = setEditorState;
    },
    willUnmount: function willUnmount() {
      store.getEditorState = undefined;
      store.setEditorState = undefined;
    },
    modifiers: {
      addEmoji: _addEmoji.default
    },
    onChange: function onChange(editorState) {
      var newEditorState = (0, _attachImmutableEntitiesToEmojis.default)(editorState);

      if (!newEditorState.getCurrentContent().equals(editorState.getCurrentContent())) {
        // Forcing the current selection ensures that it will be at it's right place.
        // This solves the issue where inserting an Emoji on OSX with Apple's Emoji
        // selector led to the right selection the data, but wrong position in
        // the contenteditable.
        newEditorState = _draftJs.EditorState.forceSelection(newEditorState, newEditorState.getSelection());
      }

      if (_onChange) {
        return _onChange(newEditorState);
      }

      return newEditorState;
    }
  };
}